import React from 'react'
import utmLinkGenerator from '../../utils/UTMLinkGenerator'

export default (props) => {
  const {
    box: {
      duration,
      featuredSize,
      featuredType,
      guid,
      images,
      link,
      source,
      title
    },
    imageBoxComponent: ImageBoxComponent,
    imageBoxComponentProps = {},
    index,
    imageSize,
    utmParams,
    abTestCampaign,
    layout,
    shouldOpenInNewTab
  } = props

  const image = images[imageSize]

  const utmLinkParams = Object.assign({}, utmParams, {
    utmTerm: `position-${index}`,
    utmCampaign: abTestCampaign || source
  })

  const utmLink = utmLinkGenerator.createLink(link, utmLinkParams)

  return (
    <ImageBoxComponent
      { ...imageBoxComponentProps }
      key={guid}
      duration={duration}
      featuredSize={featuredSize}
      featuredType={featuredType}
      image={image}
      imageClass={`image-${imageSize}`}
      isImage={true}
      link={utmLink}
      title={title}
      shouldOpenInNewTab={shouldOpenInNewTab}
      layout={layout}
    />
  )
}
